import styled from 'styled-components';

import { selfOrFunction } from '../../utils';

import { ProgressBarProps } from './types';

export const ProgressBarProgression = styled.div<{ progress: number }>`
  height: ${({ theme }) => theme.spacing(1)}px;
  border-radius: ${({ theme }) => theme.spacing(1.5)}px;
  width: ${({ progress, theme }) =>
    progress > 0 ? `clamp(0%,${progress}%,100%)` : `${theme.spacing(1)}px`};
  transition: 0.2s width linear;
`;

export const ProgressBarContainer = styled.div<
  Omit<ProgressBarProps, 'value' | 'total' | 'initial'>
>`
  height: ${({ theme }) => theme.spacing(1)}px;
  border-radius: ${({ theme }) => theme.spacing(1.5)}px;
  background-color: ${({ theme }) => theme.mosaiq.colors.grey20};

  ${ProgressBarProgression} {
    background-color: ${(props) =>
      selfOrFunction(props, props.backgroundColor) ?? props.theme.mosaiq.colors.black};
  }
`;
